import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export const useDocumentTitle = (titleOrConfig: string | { name: string }, subtitle?: string) => {
  const title = typeof titleOrConfig === 'string'
    ? titleOrConfig
    : subtitle
      ? `${subtitle} - ${titleOrConfig.name}`
      : titleOrConfig.name;

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};
